import { Box, Grid2 as Grid } from "@mui/material";
import { PageFull } from "./Pages";
import SectionTitle from "./SectionTitle";

export default function IconDesc({ title, items }) {
  return (
    <PageFull>
      <SectionTitle title={title} />
      <Grid 
        container
        justifyContent="center"
        spacing={4}
        sx={{
          padding: '5vw'
        }}
      >
        {items?.map((icon, index) => (
          <Grid
            key={index}
            sx={{
                width: {
                    xs: "100%",
                    md: "50%",
                    lg: "33%",
                    xl: "25%",
                },
                maxHeight: '50vh',
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                boxShadow: 3,
                transition: "box-shadow 0.3s ease",
                "&:hover": {
                    boxShadow: 5,
                },
                position: "relative",
                borderRadius: "20px",
            }}
          >
                <Box
                  component="img"
                  src={icon?.img}
                  alt="Icon"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "20px",
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.6)", 
                    color: "white",
                    padding: "20px",
                    fontSize: "0.8rem",
                    textAlign: "center",
                    borderRadius: "0 0 20px 20px",
                  }}
                >
                  {icon.description}
                </Box>
            </Grid>
        ))}
      </Grid>
    </PageFull>
  );
}
